export default {
  methods: {
    /**
     * Load tags on a profile page
     *
     * @return void
     */
    loadTags () {
      if (typeof this.user.id !== 'undefined') {
        this.getTalentTags({ id: this.user.id })
          .then(() => {
            this.tagsHaveBeenPreloaded = true
          })
      }
    },

    loadPaymentDetails () {
      if (typeof this.user.id !== 'undefined') {
        this.getUserPaymentDetails({ id: this.user.id })
          .then(() => {
            this.paymentDetailsHaveBeenLoaded = true
          }).catch((e) => {
            this.paymentDetailsHaveBeenLoaded = false
          })
      }
    },

    loadTalentBudget () {
      this.getTalentOpportunityBudget({id: this.$route.params.id})
        .then(() => {
          this.talentBudgetsHaveBeenPreLoaded = true
        })
    }
  }
}
